module.exports = __webpack_public_path__ + "6b427452c503788eb78e58e91565cab0.pdf";